export default __webpack_public_path__ + "static/media/Ntorq125FI_LateralIzq.ff399f42.webp";